// Percorso file: src/pages/Home.jsx
//
// INSTRADATORE (rotta /home) — riscritto da zero.
//
// I controlli globali (auth pronta, utente presente, ARCHIVED, PENDING)
// NON sono duplicati qui: /home è avvolta in App.jsx dallo stesso
// cancello condiviso RequireRole che protegge tutte le home, così i
// controlli sono letteralmente gli stessi, non due copie che possono
// divergere. Quando questo componente viene eseguito, l'utente esiste
// ed è attivo.
//
// Restano le tre sole decisioni di instradamento (diario, decisione B):
//   - un solo ruolo posseduto → dritto alla sua home (ROLE_ROUTES)
//   - due o più ruoli         → SEMPRE la finestra di scelta, senza
//                               memoria dell'ultima veste
//   - nessun ruolo, o ruolo   → schermata esplicita con il ruolo trovato
//     fuori dalla mappa         e il Logout della barra utente
//
// Qui muore il rimbalzo /home ↔ /login dell'instradatore vecchio
// (audit 08 §1.2): un ruolo sconosciuto non rimanda più al login.

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { UnknownRoleView } from "../components/SystemView";
import { getActiveRoles, ROLE_ROUTES } from "../auth/access";

const Home = () => {
  const { user } = useAuth();
  const roles = getActiveRoles(user);

  if (roles.length >= 2) return <Navigate to="/home/context" replace />;

  if (roles.length === 1 && ROLE_ROUTES[roles[0]]) {
    return <Navigate to={ROLE_ROUTES[roles[0]]} replace />;
  }

  return <UnknownRoleView roles={roles} />;
};

export default Home;
